// pages/NotFoundPage.jsx - 404 Not Found Page
import React from 'react'
import { Link } from 'react-router-dom'
import { TreePine, Home, ArrowLeft } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        {/* Icon */}
        <div className="w-24 h-24 mx-auto bg-arbor-100 rounded-full flex items-center justify-center">
          <TreePine className="w-12 h-12 text-arbor-500" />
        </div>
        
        {/* Message */}
        <h1 className="mt-6 text-4xl font-bold text-gray-900">404</h1>
        <p className="mt-2 text-xl text-gray-600">Page Not Found</p>
        <p className="mt-4 text-gray-500 max-w-md mx-auto">
          The page you're looking for doesn't exist or the form link may have expired.
        </p>
        
        {/* Actions */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/admin"
            className="btn-primary flex items-center justify-center gap-2"
          >
            <Home className="w-5 h-5" />
            Go to Dashboard
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="btn-secondary flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Go Back
          </button>
        </div>
        
        {/* Help text */}
        <p className="mt-8 text-sm text-gray-400">
          If you believe this is an error, please contact your administrator.
        </p>
      </div>
    </div>
  )
}
